import Http from "@/commons/Http";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";

export default {

    async showWord(url, data = null, fileName, method = 'POST'){

        const config = {
            responseType: 'blob',
            timeout : 0,
            headers: {'Content-Type': 'application/json'}
        };

        let promise;
        if(method === 'POST'){
            promise = Http.post(url, data, config);
        }else{
            promise = Http.get(url, config);
        }

        return promise.then(response => {
            const urlParts = url.split('/');
            const fileNameFinal = (fileName ? fileName : urlParts[urlParts.length - 1]) + ".docx";
            const word = new Blob([response], {type: "application/octet-stream"});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(word);
            link.download = fileNameFinal;
            link.click();
        }).catch(e => {
            e.text().then(erro => {
                const error = JSON.parse(erro);
                ToastMessageBusiness.showError(error.message);
                if(error.field){
                    ToastMessageBusiness.showError(error.field);
                }
                throw error;
            });
        });

    },

    open(blob) {
        const fileURL = URL.createObjectURL(blob);
        return  window.open(fileURL, '', "toolbar=no,scrollbars=yes,resizable=no,width=1000,height=600");
    },

}